(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
    }

    onSubmitHandler(e) {
      e.preventDefault();

      const config = this.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.getSectionsToRender().map((section) => section.section)
        );
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.message);
            return;
          }

          this.getSectionsToRender().forEach((section) => {
            const HTML = new DOMParser()
              .parseFromString(
                response.sections[`${section.section}`],
                "text/html"
              )
              .querySelector(section.id).innerHTML;
            const HTMLSection = document.querySelector(section.id);
            if (HTMLSection) {
              HTMLSection.innerHTML = HTML;
            }
          });

          if (this.cart) {
            this.cart.open();
          }
      });
    }

    getSectionsToRender() {
      return [
        {
          id: "#CartMain",
          section: "cart",
        },
        {
          id: "#CartDrawer",
          section: "cart-drawer",
        },
      ];
    }

    fetchConfig(type = "json") {
      return {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/${type}`,
        },
      };
    }

    handleErrorMessage(errorMessage) {
      const errorElement = this.querySelector("[data-error]");
      errorElement.removeAttribute("hidden");
      errorElement.querySelector("[data-error-message]").textContent =
        errorMessage;
    }
  }

  customElements.define('product-form', ProductForm);
})();
